import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

// Before any checkout, make sure the stored session is still valid. A stale or
// corrupt token used to reach create-checkout and fail with a generic 500.
let installed = false;

export function installCheckoutSessionGuard() {
  if (installed || typeof window === "undefined") return;
  installed = true;
  const fns = supabase.functions as unknown as { invoke: (name: string, opts?: unknown) => Promise<{ data: unknown; error: unknown }> };
  const original = fns.invoke.bind(fns);

  const expired = async () => {
    await supabase.auth.signOut({ scope: "local" }).catch(() => undefined);
    const es = !window.location.pathname.startsWith("/en");
    const msg = es
      ? "Tu sesión ha caducado. Vuelve a entrar para completar el pago."
      : "Your session has expired. Sign in again to complete the payment.";
    toast.error(msg);
    return { data: null, error: new Error(msg) };
  };

  fns.invoke = async (name: string, opts?: unknown) => {
    if (name !== "create-checkout") return original(name, opts);
    const { error: userError } = await supabase.auth.getUser();
    if (userError) {
      const { error: refreshError } = await supabase.auth.refreshSession();
      if (refreshError) return expired();
    }
    const result = await original(name, opts);
    const status = (result.error as { context?: Response } | null)?.context?.status;
    if (status === 401) return expired();
    return result;
  };
}
